import { Modal, Form, Input} from 'antd';
import { useState } from 'react';
import {promijeniLozinku} from '../services/korisnik.service';
import authService from '../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; 
const ChangePassword = ({ visible, onClose, korisnickoIme, staraLozinka }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (values.novaLozinka !== values.potvrdaLozinke) {
       alert('Nove lozinke se ne poklapaju!');
        return;
      }
      setLoading(true);
      await promijeniLozinku({
        korisnickoIme,
        staraLozinka,
        novaLozinka: values.novaLozinka
      });

      const loginResponse = await authService.login({
        username: korisnickoIme,
        password: values.novaLozinka
      });   
      alert('Lozinka uspješno promijenjena!');
      login(loginResponse.role); 
      if (loginResponse.role === "ROLE_ADMIN") {
        navigate("/admin/home");
      } else if (loginResponse.role === "ROLE_ZAPOSLENI") {
        navigate("/zaposleni/home");
      } else {
        navigate("/home");
      }
     
      onClose();
    } catch (err) {
      alert('Greška pri promjeni lozinke');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Promjena lozinke"
      open={visible}
      onOk={handleOk}
      onCancel={onClose}
      okText="Promijeni lozinku"
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="novaLozinka"
          label="Nova lozinka"
          rules={[{ required: true, message: 'Unesite novu lozinku' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="potvrdaLozinke"
          label="Potvrdite novu lozinku"
          rules={[{ required: true, message: 'Potvrdite novu lozinku' }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
